import reducer from "./reducer";
export { default as Catalogs } from "./components/index";
export { default as catalogsReducerName } from "./constants";
export default reducer;
